"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var mobileStylesHelper_1 = require("../assets/mobileStylesHelper");

var mixins_1 = require("../theme/mixins");

var mobile = {
  width: '100%',
  border: 'none',
  borderRadius: 0,
  boxShadow: 'none',
  '& $header, & $footer': {
    paddingLeft: 16,
    paddingRight: 16
  }
};

exports.styles = function (theme) {
  return __assign({
    panel: __assign(__assign({}, mixins_1.border(theme)), {
      boxShadow: theme.depth1,
      borderRadius: theme.sizeBorderRadius,
      backgroundColor: theme.colorBg.normal,
      margin: '0 auto',
      position: 'relative',
      minWidth: 320,
      width: theme.sizePopupMedium
    }),
    header: {
      paddingTop: theme.x4,
      paddingBottom: theme.x4,
      paddingLeft: 20,
      paddingRight: 20
    },
    footer: {
      paddingTop: theme.x4,
      paddingBottom: theme.x4,
      paddingLeft: 20,
      paddingRight: 20
    },
    cross: {
      position: 'absolute',
      right: theme.x4,
      top: theme.x6,
      cursor: 'pointer'
    }
  }, mobileStylesHelper_1.default(mobile));
};